import { attachRaw, getRaw, hasRaw } from './raw'
import { attachUnknown, getUnknown, isDegraded } from './unknown'

/** Shallow clone that keeps the prototype chain and `$raw`. */
export function cloneFcdcEntity<T extends object>(entity: T): T {
  const clone = Object.assign(
    Object.create(Object.getPrototypeOf(entity)),
    entity
  ) as T
  if (hasRaw(entity)) {
    attachRaw(clone, getRaw(entity))
    attachUnknown(clone, getUnknown(entity), isDegraded(entity))
  }
  return clone
}
